module.exports = __webpack_public_path__ + "img/only-symbol-outline.ea12a887.png";